import {useCallback, useEffect, useState} from 'react';
import {useSession} from '../firebase/UserProvider';
import {useStompSubscription} from './useStompSubscription';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token ? {'Authorization': `Bearer ${token}`} : {};
}

/**
 * Fetch chats for the current user with:
 *  - refetch() to manually refresh
 *  - live STOMP subscription so the list updates when a new message arrives
 *    for this user (topic: /topic/chat/notify/{uid})
 */
function useUserChats(options = {}) {
    const {limit} = options;
    const session = useSession();
    const uid = session?.user?.uid || null;

    const [chats, setChats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tick, setTick] = useState(0);

    const refetch = useCallback(() => setTick((t) => t + 1), []);

    useEffect(() => {
        if (!uid) { setChats([]); setLoading(false); setError(null); return; }

        setLoading(true); setError(null);
        let url = `${BASE}/api/chats/by-participant/${encodeURIComponent(uid)}`;
        if (limit) url += `?limit=${limit}`;
        let cancelled = false;

        fetch(url, {headers: authHeaders()})
            .then((r) => r.ok ? r.json() : [])
            .then((data) => {
                if (!cancelled) { setChats(Array.isArray(data) ? data : []); setLoading(false); }
            })
            .catch((err) => {
                if (!cancelled) { setError(err); setLoading(false); }
            });

        return () => { cancelled = true; };
    }, [uid, limit, tick]);

    // Live updates: when a chat message arrives for this user, refresh the list
    useStompSubscription(uid ? `/topic/chat/notify/${uid}` : null, refetch);

    return {chats, loading, error, refetch};
}

export default useUserChats;
